const DATACVR_BASE = 'https://datacvr.virk.dk'

function encodeUnitId(value: string | number): string {
  return encodeURIComponent(String(value).trim())
}

/**
 * Public DataCVR page for a company (virksomhed).
 * Opens the official register view for cross-checking our app data.
 */
export function dataCvrCompanyUrl(cvrNummer: string | number): string {
  return `${DATACVR_BASE}/enhed/virksomhed/${encodeUnitId(cvrNummer)}`
}

/**
 * Public DataCVR page for a person (deltager).
 */
export function dataCvrPersonUrl(enhedsNummer: string | number): string {
  return `${DATACVR_BASE}/enhed/person/${encodeUnitId(enhedsNummer)}/deltager`
}
